import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import translations directly for better bundling
import translationsEN from "./locales/en/translations.json";

i18n
    .use(initReactI18next)
    .init({
        lng: "en",
        fallbackLng: "en",
        debug: false, // Disable debug in production

        resources: {
            en: {
                translations: translationsEN
            }
        },
        ns: ["translations"],
        defaultNS: "translations",
        interpolation: {
            escapeValue: false,
            formatSeparator: ",",
        },
        react: {
            useSuspense: true,
        },
    });

export default i18n;